//Back-end IP server
export const IP_BE = process.env.REACT_APP_API_URL;
// export const IP_BE = "https://api.breathe4school.in";
//S3 bucket
// export const IP = "http://b4spublic.s3-website.ap-south-1.amazonaws.com/";
// export const IP = "https://dxs5if5qoy7z5.cloudfront.net/";
export const IP = process.env.REACT_APP_PUBLIC_URL;
//export const IP = "http://34.131.185.191:3002";
